import { useRuntimeConfig } from '#imports';
import { appNames } from '@/lib/appNames';

export const isInaiaEu = (): boolean => {
    return useRuntimeConfig().public.CURRENT_APP === appNames.inaiaEu;
};
